import { uniframeReady } from '@spot-fe/utils';
import { useUserInfo } from '@spot-fe/base-ui';

export const useDeposit = () => {
  const { isLogin, isUTA, isSub, isUnified } = useUserInfo();

  const open = async (coin: string) => {
    await uniframeReady();
    return new Promise((resolve, reject) => {
      (window as any)?.BybitUniFrame?.ready(({ deposit }) => {
        const { THEME, VISIBILE, COIN, PATH_NAME } = deposit.properties;
        const { HIDE_MODAL } = deposit.events;

        deposit
          .init()
          .then(() => {
            // setReadyState(1);
            // depositRef.current = deposit;
            deposit
              .setProperty(COIN, coin)
              .setProperty(THEME, 'theme-dark')
              .setProperty(PATH_NAME, 'premarket')
              .setProperty(VISIBILE, true);
          })
          .catch(() => {
            // setReadyState(0);
          });
      });
    });
  };

  const init = async () => {
    await uniframeReady();

    return new Promise((resolve, reject) => {
      (window as any)?.BybitUniFrame?.ready(({ transfer, upgradeUnifiedAccount }) => {
        transfer.init().then(() => {
          resolve(true);
        });

        upgradeUnifiedAccount.init();
      });
    });
  };

  const openTransfer = async (coin: string, onSuccess?: () => void) => {
    await uniframeReady();

    return new Promise((resolve, reject) => {
      (window as any)?.BybitUniFrame?.ready(({ transfer }) => {
        const {
          THEME,
          DEFAULT_FROM,
          DEFAULT_TO,
          LOCK_ACCOUNTS,
          VISIBILE,
          PATH_NAME,
          DIRECTION,
          COIN,
          TRANSFER_TYPE,
          TO_DATA,
        } = transfer.properties;
        const { HIDE_MODAL, TRANSFER_COMPLETE, TRANSFER_FAIL } =
          transfer.events;
        // eslint-disable-next-line
        // const { is_submember: isSubmember } = store.state.user.info; // 是否为子账号
        // const isUTA = store.getters['user/isUTA']; // 是否升级为统统一账户
        const accountEnum = {
          // 统保账户
          UNIFIED: 'ACCOUNT_TYPE_UNIFIED',
          // 现货账户
          SPOT: 'ACCOUNT_TYPE_SPOT',
          // 通用账户（合约账户）
          CONTRACT: 'ACCOUNT_TYPE_CONTRACT',
          // 资金账户
          FUND: 'ACCOUNT_TYPE_FUND',
        };

        // const fromAccount = isUTA ? accountEnum.UNIFIED : accountEnum.SPOT;
        // const toAccount = isSub ? accountEnum.CONTRACT : accountEnum.FUND;

        // todo: 确定是否 settletoken
        const defaultCoin = 'USDT';

        transfer.init().then(() => {
          transfer
            .setProperty(THEME, 'light')
            .setProperty(DEFAULT_FROM, accountEnum.FUND)
            .setProperty(DEFAULT_TO, accountEnum.UNIFIED)
            .setProperty(TO_DATA, {
              aid: accountEnum.UNIFIED
            })
            .setProperty(TRANSFER_TYPE, 2)
            .setProperty(DIRECTION, 'two')
            .setProperty(PATH_NAME, 'preMarket')
            .setProperty(COIN, defaultCoin || coin)
            .setProperty(VISIBILE, true);

          transfer.subscribeEvent(HIDE_MODAL, () => {
            transfer.setProperty(VISIBILE, false);
          });

          transfer.subscribeEvent(TRANSFER_COMPLETE, () => {
            transfer.setProperty(VISIBILE, false);
            onSuccess?.();
          });
        });
      });
    });
  };

  const openUtaUpgradeDialog = async () => {
    // upgradeUnifiedAccount
    await uniframeReady();

    const accountEnum = {
      // 普通账户
      GENERAL: '0',
      // 统保账户
      UNIFIED: '1',
    };
    const userUpgradeState = '0';

    return new Promise((resolve, reject) => {
      (window as any)?.BybitUniFrame?.ready(({ upgradeUnifiedAccount }) => {
        const { THEME, USER_TYPE, MODAL_VISIBLE, UPGRADE_STATUS } =
          upgradeUnifiedAccount.properties;
        const { CLOSE, SUCESS_CALLBACK } = upgradeUnifiedAccount.events;

        upgradeUnifiedAccount
          .init()
          .then(() => {
            // setReadyState(1);
            // depositRef.current = deposit;
            upgradeUnifiedAccount
              .setProperty(THEME, 'theme-light')
              .setProperty(
                USER_TYPE,
                isUnified ? accountEnum.UNIFIED : accountEnum.GENERAL
              )
              .setProperty(MODAL_VISIBLE, true)
              .setProperty(UPGRADE_STATUS, userUpgradeState);

            upgradeUnifiedAccount
              .subscribeEvent(SUCESS_CALLBACK, () => {
                // 用户升级成功，直接刷新页面
                window.location.reload();
              })
              .subscribeEvent(CLOSE, () => {
                upgradeUnifiedAccount.setProperty(MODAL_VISIBLE, false);
              });
          })
          .catch(() => {
            // setReadyState(0);
          });
      });
    });
  };

  return {
    // visible,
    init,
    open,
    openTransfer,
    openUtaUpgradeDialog,
    // close
  };
};
